import us from './english.js'
import de from './de.js'
import es from './es.js'
import it from './it.js'
import fr from './fr.js'

export function getConfiguration(locale?: string) {
  const lowercaseLocale = locale?.toLocaleLowerCase()

  switch (lowercaseLocale) {
    case 'es':
      return es
    case 'fr':
      return fr
    case 'de':
      return de
    case 'it':
      return it
    default:
      return us
  }
}

export function getTopCategoriesByLocale(locale: string) {
  const lowercaseLocale = locale.toLocaleLowerCase()

  switch (lowercaseLocale) {
    case 'es':
      return es
    case 'fr':
      return fr
    case 'de':
      return de
    case 'it':
      return it
    default:
      return us
  }
}
